import * as React from 'react';
import styled from 'styled-components';
import { useCSVReader as CSVReader } from 'react-papaparse';
import { setEntityCSV  } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';
import { Entities } from '@process-advisor/process-miner/eventLog/entities';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    margin-top: 15px;
`;

const SingleBlockCSV = styled(SingleBlock)`
    margin-top: 15px;
    margin-left: 15px;
`;

const SingleBlockEntities = styled(SingleBlock)`
    margin-top: 25px;
    margin-bottom: 10px;
    margin-left: 15px;
`;
type Props = {
    nextDisabled: (value: boolean) => void;
};

export const UploadCSV: React.FC<Props> = ({ nextDisabled }) => {

    const handleOnDrop = (data, file) => {
        apiProvider.uploadEventLog({ csv: data, filename: file.name })
//        setProps({
//            functionToLoad: () => apiProvider.uploadEventLog({ csv: data, filename: file.name }),
//        });
        apiProvider.alertMessage({
            message: 'CSV file uploaded',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'upload_file',
        });
        nextDisabled(false);
    };

    const handleOnError = () => {
        nextDisabled(false);
    };

    const handleOnRemoveFile = () => {
        nextDisabled(true);
    };

    React.useEffect(() => {
        setEntityCSV('Issue')
    }, []);

    return (
        <Wrapper>
            <SingleBlockCSV>
                <CSVReader
                    onDrop={handleOnDrop}
                    onError={handleOnError}
                    addRemoveButton
                    removeButtonColor="#659cef"
                    onRemoveFile={handleOnRemoveFile}
                >
                    <span>Drop your Event Log CSV file here or click to upload</span>
                </CSVReader>
            </SingleBlockCSV>
            <SingleBlockEntities width="15%">
                <Section title='Process Entity:'/>
            </SingleBlockEntities>
            <SingleBlockEntities width="80%">
                <Entities/>
            </SingleBlockEntities>
        <AlertMessage />
        </Wrapper>
    );
};
